(() => {
  const ADDED_DURATION = 2500;

  const showAddedState = (button, template) => {
    if (button.dataset.salutAdded === 'true') return;
    const added = template.content.firstElementChild.cloneNode(true);
    button.dataset.salutAdded = 'true';
    button.classList.add('salut-cta--added');
    button.appendChild(added);
    setTimeout(() => {
      added.remove();
      button.classList.remove('salut-cta--added');
      delete button.dataset.salutAdded;
    }, ADDED_DURATION);
  };

  const watch = (form) => {
    const button = form.querySelector('.product-form__submit');
    const template = form.parentElement.closest('div')?.querySelector('[data-salut-cta-added]')
      || form.closest('.product__info-panel')?.querySelector('[data-salut-cta-added]');
    if (!button || !template) return;

    let pending = false;
    form.addEventListener('submit', () => { pending = true; });

    new MutationObserver(() => {
      if (!pending || button.getAttribute('aria-disabled') === 'true') return;
      pending = false;
      showAddedState(button, template);
    }).observe(button, { attributes: true, attributeFilter: ['aria-disabled'] });
  };

  const init = () => document.querySelectorAll('.salut-product .main-atc-form').forEach(watch);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
